export default "/dist/files/like-plein2-stroke.58430db82229396f129b3e2fe94a75b0.svg";